const Promotions = {
    startTime: "1765941300000",
    endTime: "1767292200000",
    price: {
        elite: "499",
        intro: "0",
        upgrade: "199"
    },
    cashback: {
        elite: "3"
    }
}

export default Promotions;

